<script lang="ts">
	import { Icon, Tooltip } from '@repo/commons/components'
	import { t } from 'svelte-i18n'

	const label = $derived($t('ResourceSchemaColumnsView.primaryKey'))
</script>

<Tooltip text={label} position="top" tooltipSize="small" delay={100} offset={8}>
	<span class="primary-key-icon">
		<Icon name="key" size="sm" aria-label={label} />
	</span>
</Tooltip>

<style lang="postcss">
	.primary-key-icon {
		@apply inline-flex shrink-0 items-center;

		color: #007acccc;
	}
</style>
